import { render } from "./BusinessInfo_profit_loss.vue?vue&type=template&id=59d9409a&scoped=true"
import script from "./BusinessInfo_profit_loss.vue?vue&type=script&lang=js"
export * from "./BusinessInfo_profit_loss.vue?vue&type=script&lang=js"

import "./BusinessInfo_profit_loss.vue?vue&type=style&index=0&id=59d9409a&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d9409a"]])

export default __exports__